import React from 'react';
import { Fade } from 'react-awesome-reveal';
import { Node } from '@uncinc/react-drupal-core';

import { DEFAULT_FADE_DURATION_MS } from '../../config/constants';

import './style.scss';

const KPAnswersTeasers = ({ entities }) => {
  return (
    <div className="KPAnswersTeasers">
      <div className="row">
        {entities.map((entity) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const className = 'col-12 col-lg-4';
          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Fade triggerOnce duration={DEFAULT_FADE_DURATION_MS}>
                <Node
                  id={id}
                  key={`${uuid}:${langcode}`}
                  isActivePath
                  entity={entity}
                  viewMode="teaser"
                />
              </Fade>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default KPAnswersTeasers;
